import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type ValueLimit from '@linc-technologies/linced-common/models/events/value-limit';

// Proto: events.OptionLimit.
export default class OptionLimit extends Fragment {
  declare [Type]: 'events/option-limit';

  @attr('string', { defaultValue: '' })
  declare optionId: string;

  @attr('number', { defaultValue: 0 })
  declare limit: number;

  @fragmentArray('events/value-limit')
  declare valueLimits: FragmentArray<ValueLimit>;
}
